import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  serializer1cdzkc3mnhoc4 as serializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  SetSerializert3lb0yy9iftr as SetSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  plus20p0vtfmu0596 as plus,
  toMutableList20rdgwi7d3cwi as toMutableList,
  toList3jhuyej2anx2q as toList,
  toSet2orjxp16sotqu as toSet,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
  Collection1k04j3hzsbod0 as Collection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { listElement2fr0t0e999y76 as listElement } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { plus18eogev54fmsa as plus_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitqeg6zusi9ora as await_1,
} from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { default308h22k6ofhww as default_0 } from '../../../../../lightning-server-shared/com/lightningkite/serialization/Defaults.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  FormLayoutPreferences_Field_getInstanceniwfeoycub95 as FormLayoutPreferences_Field_getInstance,
  FormLayoutPreferences_Block_getInstance2bsp7v6nfhpj1 as FormLayoutPreferences_Block_getInstance,
} from './helpers.mjs';
import { SerializableAnnotation2h7cqfq6xt1yy as SerializableAnnotation } from '../../../../../lightning-server-shared/com/lightningkite/serialization/VirtualType.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  FormRendererv0cfjgipxuxv as FormRenderer,
  Companion_instancegwok6qx7et5m as Companion_instance,
  FormSelector1zdq40oqbcvms as FormSelector,
  ViewRenderer1i6kznnbg7y21 as ViewRenderer,
  Companion_instance17v8p6g2424o4 as Companion_instance_0,
  get_kind27kjvyfnc9an8 as get_kind,
  get_nullable1f61etx34dvfo as get_nullable,
  get_annotation27eynvnd00ffx as get_annotation,
  get_handlesField2upaii4zzjnxm as get_handlesField,
  get_basePriority3aha966bwjyn2 as get_basePriority,
  priority7vn90mx06311 as priority,
  matches2uu672wulv59r as matches,
  Generator2kgtccb0jt0mi as Generator,
  Generator1qrulkrel7e5m as Generator_0,
} from './FormRenderer.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_scrollsHorizontally166yklfalehnr as get_scrollsHorizontally } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { lensByElementAssumingSetNeverManipulates1yt8q6qtxcnsa as lensByElementAssumingSetNeverManipulates } from '../../../../../reactive/com/lightningkite/reactive/lensing/LensByElementAssumingSetNeverManipulates.mjs';
import { CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { flattenml92kmikh8fo as flatten } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { Companion_getInstance2a03ktg5l3ejl as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { text1v7b2bj2gx49v as text } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HorizontalListRendererClass;
function HorizontalListRenderer() {
  if (HorizontalListRendererClass === VOID) {
    class $ extends ListRenderer() {
      constructor() {
        HorizontalListRenderer_instance = null;
        super();
        HorizontalListRenderer_instance = this;
        this.ydy_1 = false;
        this.zdy_1 = 'List';
        this.adz_1 = ListSerializer(serializer(Unit_instance)).az().h10();
      }
      bdz() {
        return this.ydy_1;
      }
      cdz() {
        return this.zdy_1;
      }
      h94() {
        return this.adz_1;
      }
      ddz(collection, item) {
        return plus(collection, item);
      }
      edz(collection, item) {
        return this.ddz((!(collection == null) ? isInterface(collection, KtList()) : false) ? collection : THROW_CCE(), item);
      }
      fdz(collection, item, index) {
        // Inline function 'kotlin.apply' call
        var this_0 = toMutableList(collection);
        this_0.z3(index);
        return this_0;
      }
      gdz(collection, item, index) {
        return this.fdz((!(collection == null) ? isInterface(collection, KtList()) : false) ? collection : THROW_CCE(), item, index);
      }
      hdz(readable) {
        return readable;
      }
      idz(readable) {
        return this.hdz(readable);
      }
      jdz(mutable) {
        return mutable;
      }
      kdz(mutable) {
        return this.jdz(mutable);
      }
      ldz(serializer) {
        return ensureNotNull(listElement(serializer));
      }
      mdz(serializer) {
        return this.ldz(serializer);
      }
    }
    initMetadataForObject($, 'HorizontalListRenderer');
    HorizontalListRendererClass = $;
  }
  return HorizontalListRendererClass;
}
var HorizontalListRenderer_instance;
function HorizontalListRenderer_getInstance() {
  if (HorizontalListRenderer_instance === VOID)
    new (HorizontalListRenderer())();
  return HorizontalListRenderer_instance;
}
var VerticalListRendererClass;
function VerticalListRenderer() {
  if (VerticalListRendererClass === VOID) {
    class $ extends ListRenderer() {
      constructor() {
        VerticalListRenderer_instance = null;
        super();
        VerticalListRenderer_instance = this;
        this.ndz_1 = true;
        this.odz_1 = 'List';
        this.pdz_1 = ListSerializer(serializer(Unit_instance)).az().h10();
      }
      bdz() {
        return this.ndz_1;
      }
      cdz() {
        return this.odz_1;
      }
      h94() {
        return this.pdz_1;
      }
      ddz(collection, item) {
        return plus(collection, item);
      }
      edz(collection, item) {
        return this.ddz((!(collection == null) ? isInterface(collection, KtList()) : false) ? collection : THROW_CCE(), item);
      }
      fdz(collection, item, index) {
        // Inline function 'kotlin.apply' call
        var this_0 = toMutableList(collection);
        this_0.z3(index);
        return this_0;
      }
      gdz(collection, item, index) {
        return this.fdz((!(collection == null) ? isInterface(collection, KtList()) : false) ? collection : THROW_CCE(), item, index);
      }
      hdz(readable) {
        return readable;
      }
      idz(readable) {
        return this.hdz(readable);
      }
      jdz(mutable) {
        return mutable;
      }
      kdz(mutable) {
        return this.jdz(mutable);
      }
      ldz(serializer) {
        return ensureNotNull(listElement(serializer));
      }
      mdz(serializer) {
        return this.ldz(serializer);
      }
    }
    initMetadataForObject($, 'VerticalListRenderer');
    VerticalListRendererClass = $;
  }
  return VerticalListRendererClass;
}
var VerticalListRenderer_instance;
function VerticalListRenderer_getInstance() {
  if (VerticalListRenderer_instance === VOID)
    new (VerticalListRenderer())();
  return VerticalListRenderer_instance;
}
function HorizontalSetRenderer$lens$lambda(it) {
  return toList(it);
}
function HorizontalSetRenderer$lens$lambda_0(it) {
  return toList(it);
}
function HorizontalSetRenderer$lens$lambda_1(it) {
  return toSet(it);
}
var HorizontalSetRendererClass;
function HorizontalSetRenderer() {
  if (HorizontalSetRendererClass === VOID) {
    class $ extends ListRenderer() {
      constructor() {
        HorizontalSetRenderer_instance = null;
        super();
        HorizontalSetRenderer_instance = this;
        this.qdz_1 = false;
        this.rdz_1 = 'Set';
        this.sdz_1 = SetSerializer(serializer(Unit_instance)).az().h10();
      }
      bdz() {
        return this.qdz_1;
      }
      cdz() {
        return this.rdz_1;
      }
      h94() {
        return this.sdz_1;
      }
      tdz(collection, item) {
        return plus_0(collection, item);
      }
      edz(collection, item) {
        return this.tdz((!(collection == null) ? isInterface(collection, KtSet()) : false) ? collection : THROW_CCE(), item);
      }
      udz(collection, item, index) {
        // Inline function 'kotlin.apply' call
        var this_0 = toMutableSet(collection);
        this_0.w3(item);
        return this_0;
      }
      gdz(collection, item, index) {
        return this.udz((!(collection == null) ? isInterface(collection, KtSet()) : false) ? collection : THROW_CCE(), item, index);
      }
      vdz(readable) {
        return lens(readable, HorizontalSetRenderer$lens$lambda);
      }
      idz(readable) {
        return this.vdz(readable);
      }
      wdz(mutable) {
        var tmp = HorizontalSetRenderer$lens$lambda_0;
        return mutable.vak(tmp, HorizontalSetRenderer$lens$lambda_1);
      }
      kdz(mutable) {
        return this.wdz(mutable);
      }
      xdz(serializer) {
        return ensureNotNull(listElement(serializer));
      }
      mdz(serializer) {
        return this.xdz(serializer);
      }
    }
    initMetadataForObject($, 'HorizontalSetRenderer');
    HorizontalSetRendererClass = $;
  }
  return HorizontalSetRendererClass;
}
var HorizontalSetRenderer_instance;
function HorizontalSetRenderer_getInstance() {
  if (HorizontalSetRenderer_instance === VOID)
    new (HorizontalSetRenderer())();
  return HorizontalSetRenderer_instance;
}
function VerticalSetRenderer$lens$lambda(it) {
  return toList(it);
}
function VerticalSetRenderer$lens$lambda_0(it) {
  return toList(it);
}
function VerticalSetRenderer$lens$lambda_1(it) {
  return toSet(it);
}
var VerticalSetRendererClass;
function VerticalSetRenderer() {
  if (VerticalSetRendererClass === VOID) {
    class $ extends ListRenderer() {
      constructor() {
        VerticalSetRenderer_instance = null;
        super();
        VerticalSetRenderer_instance = this;
        this.ydz_1 = true;
        this.zdz_1 = 'Set';
        this.ae0_1 = SetSerializer(serializer(Unit_instance)).az().h10();
      }
      bdz() {
        return this.ydz_1;
      }
      cdz() {
        return this.zdz_1;
      }
      h94() {
        return this.ae0_1;
      }
      tdz(collection, item) {
        return plus_0(collection, item);
      }
      edz(collection, item) {
        return this.tdz((!(collection == null) ? isInterface(collection, KtSet()) : false) ? collection : THROW_CCE(), item);
      }
      udz(collection, item, index) {
        // Inline function 'kotlin.apply' call
        var this_0 = toMutableSet(collection);
        this_0.w3(item);
        return this_0;
      }
      gdz(collection, item, index) {
        return this.udz((!(collection == null) ? isInterface(collection, KtSet()) : false) ? collection : THROW_CCE(), item, index);
      }
      vdz(readable) {
        return lens(readable, VerticalSetRenderer$lens$lambda);
      }
      idz(readable) {
        return this.vdz(readable);
      }
      wdz(mutable) {
        var tmp = VerticalSetRenderer$lens$lambda_0;
        return mutable.vak(tmp, VerticalSetRenderer$lens$lambda_1);
      }
      kdz(mutable) {
        return this.wdz(mutable);
      }
      xdz(serializer) {
        return ensureNotNull(listElement(serializer));
      }
      mdz(serializer) {
        return this.xdz(serializer);
      }
    }
    initMetadataForObject($, 'VerticalSetRenderer');
    VerticalSetRendererClass = $;
  }
  return VerticalSetRendererClass;
}
var VerticalSetRenderer_instance;
function VerticalSetRenderer_getInstance() {
  if (VerticalSetRenderer_instance === VOID)
    new (VerticalSetRenderer())();
  return VerticalSetRenderer_instance;
}
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.be0_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.de0_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = tmp_1;
  var tmp_2 = await_1(this_2, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = tmp_2;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.de0_1;
  var tmp_4 = await_0(this_3, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp$ret$3 = tmp_4;
  var tmp_5 = $this.be0_1.iah($this.ce0_1.gdz(tmp_0, tmp_3, tmp$ret$3.nas().f2()), $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ee0_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.ee0_1.iah($this.fe0_1.edz(tmp$ret$0, default_0($this.ge0_1.udx().gdu_1)), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function inner($this, module_0, selector) {
  var tmp = selector.gdu_1;
  var innerSer = $this.mdz(isInterface(tmp, KSerializer()) ? tmp : THROW_CCE());
  var tmp3_desiredSize = $this.bdz() ? FormLayoutPreferences_Block_getInstance() : FormLayoutPreferences_Field_getInstance();
  var tmp0_safe_receiver = selector.hdu_1;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.collections.find' call
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0_safe_receiver.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (element.j4s_1 === 'com.lightningkite.lightningdb.MultipleReferences') {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    tmp_0 = tmp$ret$1;
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_1;
  if (tmp1_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = plus(selector.hdu_1, new (SerializableAnnotation())('com.lightningkite.lightningdb.References', tmp1_safe_receiver.k4s_1));
  }
  var tmp2_elvis_lhs = tmp_1;
  var tmp4_annotations = tmp2_elvis_lhs == null ? selector.hdu_1 : tmp2_elvis_lhs;
  var inner = selector.copyChangingType(innerSer, tmp4_annotations, tmp3_desiredSize);
  return inner;
}
function TextView$_get_exists_$ref_ng7kb4(p0) {
  return () => p0.eba();
}
function TextView$_set_exists_$ref_8dyz5w(p0) {
  return (_this__u8e3s4) => {
    p0.dba(_this__u8e3s4);
    return Unit_instance;
  };
}
var ListRenderer$form$lambda$lambda$slambdaClass;
function ListRenderer$form$lambda$lambda$slambda() {
  if (ListRenderer$form$lambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($mutable, this$0, $it) {
        this.be0_1 = $mutable;
        this.ce0_1 = this$0;
        this.de0_1 = $it;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ListRenderer$form$lambda$lambda$slambdaClass = $;
  }
  return ListRenderer$form$lambda$lambda$slambdaClass;
}
function ListRenderer$form$lambda$lambda$slambda_0($mutable, this$0, $it) {
  var i = new (ListRenderer$form$lambda$lambda$slambda())($mutable, this$0, $it);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var ListRenderer$form$lambda$slambdaClass;
function ListRenderer$form$lambda$slambda() {
  if (ListRenderer$form$lambda$slambdaClass === VOID) {
    class $ {
      constructor($mutable, this$0, $inner) {
        this.ee0_1 = $mutable;
        this.fe0_1 = this$0;
        this.ge0_1 = $inner;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ListRenderer$form$lambda$slambdaClass = $;
  }
  return ListRenderer$form$lambda$slambdaClass;
}
function ListRenderer$form$lambda$slambda_0($mutable, this$0, $inner) {
  var i = new (ListRenderer$form$lambda$slambda())($mutable, this$0, $inner);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_exists_$ref_ng7kb4_0(p0) {
  return () => p0.eba();
}
function TextView$_set_exists_$ref_8dyz5w_0(p0) {
  return (_this__u8e3s4) => {
    p0.dba(_this__u8e3s4);
    return Unit_instance;
  };
}
var ListRendererClass;
function ListRenderer() {
  if (ListRendererClass === VOID) {
    class $ {
      i20() {
        return this.bdz() ? 'Vertical ' + this.cdz() : 'Horizontal ' + this.cdz();
      }
      kdu(module_0, selector) {
        var tmp = module_0.adu(inner(this, module_0, selector));
        var inner_0 = isInterface(tmp, FormRenderer()) ? tmp : THROW_CCE();
        return this.bdz() ? inner_0.p1().lds(VOID, inner_0.p1().ids_1 * 10 + 3) : inner_0.p1().lds((inner_0.p1().hds_1 + 3) * 10 + 3);
      }
      ndu(module_0, selector) {
        var tmp = module_0.adu(inner(this, module_0, selector));
        var inner_0 = isInterface(tmp, FormRenderer()) ? tmp : THROW_CCE();
        var tmp_0 = Companion_instance;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.odu(module_0, this, tmp_1, VOID, VOID, ($this$FormRenderer, _unused_var__etf5q3, mutable) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$FormRenderer.pc());
          var tmp0_elvis_lhs = $this$FormRenderer.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$FormRenderer : tmp0_elvis_lhs;
          $this$FormRenderer.gbb(p, view);
          view.zbm(false);
          view.zbm(this.bdz());
          if (!view.wb8_1) {
            view.kbb(get_expanding(view), get_scrollsHorizontally(view));
          }
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_exists_$ref_ng7kb4(view_0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('exists', 0, tmp, tmp_0, TextView$_set_exists_$ref_8dyz5w(view_0));
          reactiveScope(view_0, ($this$reactiveScope) => {
            var tmp = $this$reactiveScope.daj(mutable);
            var tmp$ret$0 = ((!(tmp == null) ? isInterface(tmp, Collection()) : false) ? tmp : THROW_CCE()).i1();
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_1 = view_0.vb5_1;
          var tmp_2;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength('Empty') === 0) {
            tmp_2 = '\xA0';
          } else {
            tmp_2 = 'Empty';
          }
          tmp_1.hbu(tmp_2);
          view.hbb(p_0, view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_1 = view.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.gbb(p_1, view_1);
          view_1.zbm(false);
          view_1.zbm(this.bdz());
          var tmp_3 = lensByElementAssumingSetNeverManipulates(this.kdz(mutable));
          forEachUpdating(view_1, tmp_3, VOID, ($this$forEachUpdating, it) => {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            var tmp = $this$forEachUpdating.jbb(CardSemantic_getInstance());
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view = new (RowOrCol())($this$forEachUpdating.pc());
            var tmp0_elvis_lhs = $this$forEachUpdating.ebb_1;
            var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
            $this$forEachUpdating.gbb(p, view);
            view.zbm(false);
            view.bb9(get_px(0));
            if (this.bdz()) {
              get_expanding(view);
            }
            inner_0.vds()(view, null, flatten(it));
            var tmp_0 = get_centered(view);
            // Inline function 'com.lightningkite.kiteui.views.direct.button' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_0 = new (Button())(view.pc());
            var tmp0_elvis_lhs_0 = view.ebb_1;
            var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
            view.gbb(p_0, view_0);
            icon(view_0, Companion_getInstance().vcf_1.id5(get_rem(1), get_rem(1)), 'Delete');
            onClick(view_0, VOID, VOID, ListRenderer$form$lambda$lambda$slambda_0(mutable, this, it));
            view.hbb(p_0, view_0);
            view.lbb(tmp_0, view_0);
            $this$forEachUpdating.hbb(p, view);
            $this$forEachUpdating.lbb(tmp, view);
            return Unit_instance;
          });
          view.hbb(p_1, view_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Button())(view.pc());
          var tmp0_elvis_lhs_2 = view.ebb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
          view.gbb(p_2, view_2);
          if (this.bdz()) {
            var tmp_4 = get_centered(view_2);
            // Inline function 'com.lightningkite.kiteui.views.direct.row' call
            // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
            var view_3 = new (RowOrCol())(view_2.pc());
            var tmp0_elvis_lhs_3 = view_2.ebb_1;
            var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
            view_2.gbb(p_3, view_3);
            view_3.zbm(false);
            view_3.lbb(get_centered(view_3), text(view_3, 'Add'));
            view_3.lbb(get_centered(view_3), icon(view_3, Companion_getInstance().ycf_1.id5(get_rem(1), get_rem(1)), ''));
            view_2.hbb(p_3, view_3);
            view_2.lbb(tmp_4, view_3);
          } else {
            view_2.lbb(get_centered(view_2), icon(view_2, Companion_getInstance().ycf_1.id5(get_rem(1), get_rem(1)), 'Add'));
          }
          onClick(view_2, VOID, VOID, ListRenderer$form$lambda$slambda_0(mutable, this, inner_0));
          view.hbb(p_2, view_2);
          $this$FormRenderer.hbb(p, view);
          return view;
        });
        return isInterface(tmp_2, FormRenderer()) ? tmp_2 : THROW_CCE();
      }
      pdu(module_0, selector) {
        var tmp = module_0.bdu(inner(this, module_0, selector));
        var inner_0 = isInterface(tmp, ViewRenderer()) ? tmp : THROW_CCE();
        var tmp_0 = Companion_instance_0;
        var tmp_1 = selector instanceof FormSelector() ? selector : THROW_CCE();
        var tmp_2 = tmp_0.qdu(module_0, this, tmp_1, VOID, VOID, ($this$ViewRenderer, _unused_var__etf5q3, readable) => {
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view = new (RowOrCol())($this$ViewRenderer.pc());
          var tmp0_elvis_lhs = $this$ViewRenderer.ebb_1;
          var p = tmp0_elvis_lhs == null ? $this$ViewRenderer : tmp0_elvis_lhs;
          $this$ViewRenderer.gbb(p, view);
          view.zbm(false);
          view.zbm(this.bdz());
          // Inline function 'com.lightningkite.kiteui.views.direct.text' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (TextView())(view.pc());
          var tmp0_elvis_lhs_0 = view.ebb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.gbb(p_0, view_0);
          var tmp = KMutableProperty0();
          var tmp_0 = TextView$_get_exists_$ref_ng7kb4_0(view_0);
          // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
          var this_0 = getPropertyCallableRef('exists', 0, tmp, tmp_0, TextView$_set_exists_$ref_8dyz5w_0(view_0));
          reactiveScope(view_0, ($this$reactiveScope) => {
            var tmp = $this$reactiveScope.daj(readable);
            var tmp$ret$0 = ((!(tmp == null) ? isInterface(tmp, Collection()) : false) ? tmp : THROW_CCE()).i1();
            this_0.set(tmp$ret$0);
            return Unit_instance;
          });
          // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
          var tmp_1 = view_0.vb5_1;
          var tmp_2;
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength('Empty') === 0) {
            tmp_2 = '\xA0';
          } else {
            tmp_2 = 'Empty';
          }
          tmp_1.hbu(tmp_2);
          view.hbb(p_0, view_0);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_1 = view.ebb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
          view.gbb(p_1, view_1);
          view_1.zbm(false);
          view_1.zbm(this.bdz());
          var tmp_3 = this.idz(readable);
          forEachUpdating(view_1, tmp_3, VOID, ($this$forEachUpdating, it) => {
            // Inline function 'com.lightningkite.kiteui.views.card' call
            var tmp$ret$7 = $this$forEachUpdating.jbb(CardSemantic_getInstance());
            $this$forEachUpdating.lbb(tmp$ret$7, inner_0.vds()($this$forEachUpdating, null, it));
            return Unit_instance;
          });
          view.hbb(p_1, view_1);
          $this$ViewRenderer.hbb(p, view);
          return view;
        });
        return isInterface(tmp_2, ViewRenderer()) ? tmp_2 : THROW_CCE();
      }
    }
    protoOf($).s11 = get_kind;
    protoOf($).rdu = get_nullable;
    protoOf($).sdu = get_annotation;
    protoOf($).wds = get_handlesField;
    protoOf($).edu = get_basePriority;
    protoOf($).tdu = priority;
    protoOf($).fdu = matches;
    initMetadataForClass($, 'ListRenderer', VOID, VOID, [Generator(), Generator_0()]);
    ListRendererClass = $;
  }
  return ListRendererClass;
}
//region block: exports
export {
  HorizontalListRenderer_getInstance as HorizontalListRenderer_getInstance2a2d2yjt2ymkp,
  HorizontalSetRenderer_getInstance as HorizontalSetRenderer_getInstance3gkefggjyyvww,
  VerticalListRenderer_getInstance as VerticalListRenderer_getInstance4zt7v1o9ou4j,
  VerticalSetRenderer_getInstance as VerticalSetRenderer_getInstance3io8tjnf253ym,
};
//endregion

//# sourceMappingURL=ListRenderer.mjs.map
